import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Icon } from '@/components/icons';
import { useLang } from '@/context/LanguageContext';

export default function ServiceCard({ service, large = false }) {
  const { tv, t } = useLang();
  return (
    <Link to={`/leistungen/${service.slug}`} data-testid={`service-card-${service.slug}`}
      className={`group relative block glass rounded-2xl p-6 overflow-hidden transition-[box-shadow,border-color,transform] duration-200 hover:border-[color:var(--itw-border-strong)] hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(0,0,0,0.55)] ${large ? 'sm:row-span-2' : ''}`}>
      <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: 'radial-gradient(circle, rgba(0,231,255,0.16), transparent 70%)' }} />
      <div className="relative">
        <div className="h-12 w-12 rounded-xl bg-[color:var(--itw-surface-2)] border border-[color:var(--itw-border)] grid place-items-center">
          <Icon name={service.icon} className="h-6 w-6 text-[color:var(--itw-cyan)]" />
        </div>
        <h3 className="mt-5 font-display text-xl font-semibold text-[color:var(--itw-text)] flex items-center gap-1.5">
          {tv(service.name)}
          <ArrowUpRight className="h-4 w-4 text-[color:var(--itw-cyan)] opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
        </h3>
        <p className="mt-2 text-sm text-[color:var(--itw-text-2)] leading-relaxed">{tv(service.tagline)}</p>
        {large && (
          <ul className="mt-5 space-y-2">
            {tv(service.features).slice(0, 5).map((f) => (
              <li key={f} className="flex items-center gap-2 text-sm text-[color:var(--itw-text-2)]">
                <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--itw-cyan)]" />{f}
              </li>
            ))}
          </ul>
        )}
        <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-[color:var(--itw-cyan)]">{t('sections.learnMore')}</span>
      </div>
    </Link>
  );
}
